import { initSubRoutes } from '../../../../utils/router';

const RoutesModifierQuestionsReponses = initSubRoutes({
    route: '/modifier-questions-reponses',
    subroutes: {},
    nom: 'Changer les questions et réponses secrètes',
});

export default RoutesModifierQuestionsReponses;
